import './App.css';
import DataTable from './DataTable.js'
import Kvalue from './Kvalue.js';
import React, { useState, useEffect } from 'react';
import IrushCurrentForm from './IrushCurrentForm.js';
import { getData, storeData } from './localStorage';
import { v4 as uuidv4 } from 'uuid';
import Info from './Info';



const App = () => {

  const initialState = () => getData('IBdata') || [];
  const [state, setState] = useState(initialState);
  const [Resval, setResval] = useState("");
  const [HistoryOpen , setHistoryOpen] = useState(false);

  useEffect(() => {
    // @state Info log array
    storeData('IBdata', state);
  }, [state]);

  const handleChange = (val) => {
    // IrushCurrentForm change function
    // @val value get from IrushCurrentForm
    let P1 = [3, 3, 3, 3, 5, 5, 5, 5, 10];//B10	B13	B16	B20	C10	C13	C16	C20	D16
    let P2 = [10, 13, 16, 20, 10, 13, 16, 20, 16];//B10	B13	B16	B20	C10	C13	C16	C20	D16
    let P3 = P1.map((x, i) => (x * P2[i]));// I*Factor
    let Imax = val.Imax;
    let T50 = val.T50;
    let Iac = val.Iac;
    
    let BoolIac0 = false;
    //This part is Only for one raw TBF.
    if (Imax.length === 0 || Imax === 0) {
      Imax = 0.000001;
    }

    if (Iac.length === 0 || Iac === 0) {
      Iac = 0.000001;
      BoolIac0 = true;
      
    }

    let K = Kvalue(T50);
    let res = P3.map((x, icol) => Math.floor(Math.min(x * K / Imax, P2[icol] / Iac)));

    val.id = uuidv4();
    val.res = res;
    val.BoolIac0 = BoolIac0;
    let newVal = [val, ...state];
    let len = newVal.length;
    if (len > 6) newVal = newVal.slice(0, 6);
    setResval(val);
    setState(newVal);
  };

  const handleDelete = id => {
    // Info log delete function
    // @id id from info.js to delet state
    storeData('IBlastState', state);
    let newState = state.filter(i => {
      return i.id !== id;
    });
    setState(newState);
  };

  const handleShowCard = id => {
    let resState = state.filter(i => {
      return i.id === id;
    })[0];
    setResval(resState);

  };

  const handleHisDisplay =() => {
    setHistoryOpen(!HistoryOpen);
  }
  return (
    <div className='row'>
      <IrushCurrentForm change={handleChange} />
      <DataTable
        Resval = {Resval}
      />
      {Resval &&
        <div className='col s12 data-container row'>

        <div className="history-container ">
          <button type="button" class="calculate-btn" onClick = {handleHisDisplay}>
          History logs  ☰
          </button>

        </div>
          {HistoryOpen && (state.length > 0 ? (
            <>
              {state.map((info,i) => (
                <Info
                  num ={i}
                  key={info.id}
                  id={info.id}
                  Imax={info.Imax}
                  T50={info.T50}
                  Iac={info.Iac}
                  date={info.date}
                  deleteCard={handleDelete}
                  showCard={handleShowCard}
                />
              ))}
            </>
          ) : (
              <div className='center white-text'>No log found</div>
            ))}
        </div>
      }
    </div>
  );
}

export default App;
